export default "__VITE_ASSET__50d34520__"